<div class='main-nav'>
    <div class='navbar navbar-inverse'>
        <div class='navbar-header'>
            <button type='button' class='navbar-toggle' data-toggle='collapse' data-target='.navbar-collapse' [attr.aria-expanded]='isExpanded' (click)='toggle()'>
                <span class='sr-only'>Toggle navigation</span>
                <span class='icon-bar'></span>
                <span class='icon-bar'></span>
                <span class='icon-bar'></span>
            </button>
            <a class='navbar-brand' [routerLink]='["/"]'>wFundacionDelamujer</a>
        </div>
        <div class='clearfix'></div>
        <div class='navbar-collapse collapse' [ngClass]='{ "in": isExpanded }'>
          <ul class='nav navbar-nav'>
            <!--<li [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]='{ exact: true }'>
              <a [routerLink]='["/"]' (click)='collapse()'>
                <span class='glyphicon glyphicon-home'></span> Home
              </a>
            </li>
            <li [routerLinkActive]='["link-active"]'>
              <a [routerLink]='["/counter"]' (click)='collapse()'>
                <span class='glyphicon glyphicon-education'></span> Counter
              </a>
            </li>
            <li [routerLinkActive]='["link-active"]'>
              <a [routerLink]='["/fetch-data"]' (click)='collapse()'>
                <span class='glyphicon glyphicon-th-list'></span> Fetch data
              </a>
            </li>-->
            <li [routerLinkActive]='["link-active"]'>
              <a [routerLink]='["/components/separador/SOL-123456/304"]' (click)='collapse()'>
                <span class='glyphicon glyphicon-th-list'></span> Información Separador
              </a>
            </li>
            <li>
              <a *ngIf="usuario" (click)="logout()">Cerrar sesión</a>
            </li>
          </ul>
        </div>
    </div>
</div>
